export const fontSizeDisplayNumbers = [
  '8',
  '9',
  '10',
  '11',
  '12',
  '14',
  '18',
  '24',
  '30',
  '36',
  '48',
  '60',
  '72',
  '96',
];
